import {useState} from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {useNavigate} from 'react-router-dom';

import {APP_ROUTES} from '../../../../../../const';
import usePayment from '../../../../../../hooks/providers/usePayment';
import useProfile from '../../../../../../hooks/providers/useProfile';
import useReport from '../../../../../../hooks/providers/useReport';
import {projectShape} from '../../../../../../proptypes-shapes';
import {makeHumanFriendlyUrl} from '../../../../../../utils';
import Button from '../../../../../form/buttons/Button/Button';
import ReportsList from '../ReportsList/ReportsList';

const SelectReportButton = ({project}) => {
  const {reports, embedToken} = useReport();
  const {isAdmin} = usePayment();
  const {profile} = useProfile();
  const navigate = useNavigate();

  const [isReportsListOpen, setIsReportsListOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const {is_owner: isOwner} = project;
  const userIsInvitedOnProject = !isOwner && !isAdmin;
  const userIsInProjectUsersList = (project.users || []).find(u => u.user_id?.toLowerCase() === profile?.id?.toLowerCase()) !== undefined;
  const userHasAccessToProject = userIsInvitedOnProject || userIsInProjectUsersList;
  const disabled = !embedToken || reports.length === 0 || !userHasAccessToProject;
  const hasTooltip = !embedToken || !userHasAccessToProject;

  const getReportUrl = report => {
    return makeHumanFriendlyUrl(APP_ROUTES.report(report.report_name));
  };

  const getTooltipMessage = () => {
    if (!embedToken) {
      return 'Rapports bientôt disponibles.';
    }

    if (isAdmin && !userIsInProjectUsersList) {
      return "Ajoutez-vous en tant qu'utilisateur pour accéder aux rapports";
    }

    return '';
  };

  const tooltipMessage = getTooltipMessage();

  const handleReportClick = report => {
    const url = getReportUrl(report);
    navigate(url, {
      state: {
        reportId: report.report_id,
        projectSiren: project.siren
      }
    });
  };

  return (
    <>
      <Button
        disabled={disabled}
        hasTooltip={hasTooltip}
        tooltip={tooltipMessage}
        endIcon={<KeyboardArrowDownIcon />}
        size="small"
        variant="contained"
        color="secondary"
        sx={{fontSize: 13}}
        onClick={e => {
          setIsReportsListOpen(true);
          setAnchorEl(e.currentTarget);
        }}
      >
        Choisir un rapport
      </Button>
      <ReportsList project={project} handleReportClick={handleReportClick} anchorEl={anchorEl} isOpen={isReportsListOpen} onClose={() => setIsReportsListOpen(false)} />
    </>
  );
};

SelectReportButton.propTypes = {
  project: projectShape.isRequired
};

export default SelectReportButton;
